import matchPath from 'react-router/matchPath';
import isEmpty from 'lodash/isEmpty';
import Home from 'containers/Home.container';
import Listings from 'containers/Listings.container';
import ListingPage from 'containers/ListingPage.container';
import Booking from 'containers/Booking.container';
import { fetchListings, fetchSingleListing } from 'listing/listing.actions';

function populateListings(store, query) {
  if (isEmpty(query)) {
    store.dispatch(fetchListings({ isSearch: true, initial: true }));
  } else {
    store.dispatch(fetchListings({ ...query, isSearch: true, initial: true }));
  }
}


const home = {
  path: "/",
  component: Home,
  init(store, query) {
    store.dispatch(fetchListings({ isSearch: true }));
  },
  isFetching(state) {
    return state.website.isFetching
  }
};

const listings = {
  path: "/listings",
  component: Listings,
  init(store, query) {
    populateListings(store, query);
  },
  isFetching(state) {
    return state.listings.initial
  }
};

const listingPage = {
  path: "/listings/:id",
  component: ListingPage,
  init(store, query) {
    store.dispatch(fetchSingleListing(this.match.params.id, query.startDate, query.endDate, true));
    populateListings(store, query);
  },
  isFetching(state) {
    return state.listings.singleInitial;
  }
};

const bookingPage = {
  path: "/listings/:id/book",
  component: Booking,
  init: listingPage.init,
  isFetching(state) {
    return state.listings.initial;
  }
};

const routes = [
  home,
  listings,
  listingPage,
  bookingPage
];

export default routes;

export function getRoute(location) {
  for (let i=0,ii=routes.length;i<ii;i++) {
    let route = routes[i];
    let match = matchPath(location.pathname, { path: routes[i].path, exact: true });
    if (match) return { ...route, match };
  }
}


// WEBPACK FOOTER //
// ./src/routes.js